import { ApolloClient, CombinedGraphQLErrors, HttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { ErrorLink } from "@apollo/client/link/error";
import { handleSessionExpired } from "../utils/session";

const getAuthToken = () => {
  return localStorage.getItem("customer_auth_token") || "";
};

export const createApolloClient = (withAuth = false) => {
  const httpLink = new HttpLink({
    uri: process.env.REACT_APP_API_URL,
    credentials: "omit",
  });

  if (!withAuth) {
    return new ApolloClient({
      link: httpLink,
      cache: new InMemoryCache(),
    });
  }

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "content-type": "application/json",
      authorization: `Bearer ${getAuthToken()}`,
    },
  }));

  // Saved login no longer valid (expired, or the server was updated): sign in again
  const sessionLink = new ErrorLink(({ error }) => {
    if (
      CombinedGraphQLErrors.is(error) &&
      error.errors.some((e) => e.extensions?.code === "UNAUTHENTICATED")
    ) {
      handleSessionExpired();
    }
  });

  return new ApolloClient({
    link: sessionLink.concat(authLink).concat(httpLink),
    cache: new InMemoryCache(),
  });
};
